var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvgLifecycleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 1,
    height: 1.00005,
    rx: 0.5,
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.12732,
    y: 3.0947,
    width: 0.965013,
    height: 1.29208,
    rx: 0.482507,
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.11487,
    y: 6.5628,
    width: 0.965013,
    height: 3.52824,
    rx: 0.482507,
    transform: "rotate(-45 5.11487 6.5628)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.29211,
    y: 6.85091,
    width: 0.965013,
    height: 2.06918,
    rx: 0.482507,
    transform: "rotate(39.8521 8.29211 6.85091)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.12732,
    y: 12.5637,
    width: 0.965013,
    height: 1.29208,
    rx: 0.482507,
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9933,
    y: 7.89285,
    width: 0.965013,
    height: 1.29208,
    rx: 0.482507,
    transform: "rotate(90 12.9933 7.89285)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.63293,
    y: 7.89285,
    width: 0.965013,
    height: 1.29208,
    rx: 0.482507,
    transform: "rotate(90 3.63293 7.89285)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.78369,
    y: 1.3866,
    width: 0.965013,
    height: 2.43532,
    rx: 0.482507,
    transform: "rotate(7.28067 3.78369 1.3866)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.2122,
    y: 7.80682,
    width: 0.965013,
    height: 2.43532,
    rx: 0.482507,
    transform: "rotate(122.468 15.2122 7.80682)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.88599,
    y: 14.7939,
    width: 0.965013,
    height: 2.43532,
    rx: 0.482507,
    transform: "rotate(-117.532 3.88599 14.7939)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.6943,
    y: 8.62085,
    width: 0.965014,
    height: 2.4325,
    rx: 0.482507,
    transform: "rotate(-147.532 14.6943 8.62085)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.74072,
    y: 1.50882,
    width: 0.965014,
    height: 2.4325,
    rx: 0.482507,
    transform: "rotate(97.2807 4.74072 1.50882)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.44019,
    y: 13.9384,
    width: 0.965014,
    height: 2.4325,
    rx: 0.482507,
    transform: "rotate(-27.5324 3.44019 13.9384)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4116 2.35519C8.85509 1.59476 7.14325 1.51323 6.01677 1.81514C5.75004 1.88662 5.45457 1.77412 5.34283 1.5216C5.23108 1.26908 5.34477 0.971882 5.60903 0.891745C7.01015 0.466853 9.0489 0.576487 10.8506 1.45668C12.8029 2.41046 14.4952 4.27623 14.863 7.35178C14.8958 7.62597 14.6868 7.86599 14.4113 7.88529C14.1358 7.90459 13.8984 7.69614 13.8641 7.42214C13.5272 4.73028 12.0648 3.16285 10.4116 2.35519Z",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17065 8.34795C1.28278 10.0924 2.07936 11.6331 2.95126 12.4711C3.15035 12.6625 3.20571 12.9736 3.04629 13.1991C2.88688 13.4246 2.57331 13.4796 2.3683 13.2946C1.24069 12.2771 0.302607 10.4329 0.172706 8.4121C0.032695 6.23403 0.828351 3.83309 3.30839 1.97803C3.52952 1.81263 3.84185 1.87361 3.9963 2.10252C4.15075 2.33143 4.08895 2.64126 3.86872 2.80786C1.70101 4.44771 1.05212 6.50418 1.17065 8.34795Z",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58536 14.079C7.92195 14.6163 6.19624 14.4422 5.09631 13.9396C4.84515 13.8248 4.53541 13.8878 4.38436 14.1189C4.23332 14.3501 4.29753 14.6619 4.54496 14.7845C5.90584 15.4589 7.9658 15.653 9.89272 15.0306C11.9696 14.3597 13.9097 12.7368 14.7226 9.74837C14.7951 9.48191 14.6235 9.2139 14.3539 9.15446C14.0842 9.09503 13.8188 9.26645 13.7449 9.53251C13.0172 12.1514 11.3435 13.5111 9.58536 14.079Z",
    fill: "#000F35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgLifecycleIcon);
export default __webpack_public_path__ + "static/media/avgLifecycle_icon.9db79d74c624b51ba7b2c44b63c1a87a.svg";
export { ForwardRef as ReactComponent };